import { CYBER_CONSTANT } from 'constants';

import React, {
  Suspense, lazy,
} from 'react';
import {
  Typography, Grid,
} from '@genie-ui/react';
import { useSelector } from 'react-redux';

import FullscreenLoader from 'components/atoms/fullscreenloader';
import GravityLayout from 'components/atoms/gravitylayout';

const PrintPPTX = lazy(() => import('components/atoms/printpptx'));

function CyberFirstContainer() {
  const {
    showPrint,
  } = useSelector(
    (state) => state.cyber,
  );

  return (
    <Grid className="firstContainer-cyber">
      <GravityLayout>
        <div className="firstPadding">
          <Typography className="containerHeader-cyber">
            {CYBER_CONSTANT.SUBHEADER.HEADER}
          </Typography>
          <Typography className="containerSubHeader">
            {CYBER_CONSTANT.SUBHEADER.SUBHEADER_1}
          </Typography>
        </div>
      </GravityLayout>

      {showPrint && (
        <Suspense fallback={<FullscreenLoader />}>
          <PrintPPTX />
        </Suspense>
      )}
    </Grid>
  );
}

export default CyberFirstContainer;
